import View from "../../../Nav/Js/views/NavigationHistoryView";
import components from "./components.js";
components.define("js-NavigationHistory", View);